import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-pick-menu-clean',
  templateUrl: './pick-menu-clean.component.html',
  styleUrls: ['./pick-menu-clean.component.scss'],
})
export class PickMenuCleanComponent implements OnInit {

  @Output() onBack = new EventEmitter<boolean>();

  constructor( public translateService: TranslateService ) { }

  back() {
    console.log('back');
    this.onBack.emit();
  }

  ngOnInit() {}

}
